<template>
	<div>
		<div v-dragDialog class="konwledge-diog-cls" id="konwledgeDiog">
			<div class="konwledge-diog-header-cls">
				<div class="left-header-cls" :class="{'is-unfold-sidebar-width': isUnfoldSidebar}">
					<div>
						<img class="logo" :src="avatar+'?imageView2/1/w/80/h/80'">
						<span>{{name}}</span>
						<el-tooltip effect="light" content="暂无数据" placement="left">
							<el-badge>
								<svg-icon class="msg" icon-class="KnowMsg" />
							</el-badge>
						</el-tooltip>
					</div>
				</div>
				<div class="right-header-cls" :class="{'is-unfold-content-width': isUnfoldSidebar}">
					<svg-icon @click.stop="handleUnfold" icon-class="KnowUnfold" />
					<span class="title">智能助手</span>
					<svg-icon @click.stop="handleClose" icon-class="KnowClose" />
					<!-- <svg-icon icon-class="KnowReport" /> -->
				</div>
			</div>
			<!-- 底部 -->
			<div class="konwledge-diog-content-cls">
				<div class="left-content-cls" :class="{'is-unfold-sidebar-width': isUnfoldSidebar}">
					<div>
						<div class="update"><svg-icon icon-class="KnowUpdate" /> 最近更新
							<el-tooltip effect="light" content="暂无数据" placement="right">
								<i>0</i>
							</el-tooltip>
						</div>
						<div class="title"><svg-icon icon-class="Knowkk" /> 全部资源</div>
						<el-tree ref="tree" @node-click="handleTreeClick" :accordion="true" :current-node-key="currentNodeId" node-key="id" :highlight-current="true" :load="loadNode" :props="defaultProps" lazy :expand-on-click-node="false" icon-class="el-icon-arrow-right">
							<span class="custom-tree-node" slot-scope="{ node }">
								<svg-icon v-if="node.level === 1" icon-class="KnowK" />
								<span> {{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</div>
				<div class="right-content-cls" :class="{'is-unfold-content-width': isUnfoldSidebar}">
					<div class="carousel-cls">
						<el-carousel arrow="never" trigger="click" height="56px" :interval="5000">
							<el-carousel-item v-for="(item, index) in newList" :key="index">
								<div class="context">
									<div @click.stop="handleBigScreenInfo(_item, _item.type == '2' ? 'process' : '')" v-for="(_item, _index) in item" :key="_index" class="cell">
										<div>
											<i>new</i>
											<span>{{ _item.q }}</span>
										</div>
										<!-- <div v-if="_item.parentNode">
											<span v-for="(v, i) in _item.parentNode" :key="i">{{v.name}} <i> / </i></span>
										</div> -->
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="query-cls">
						<svg-icon icon-class="Knowjqr" />
						<!-- <el-input v-model="serachQuery.search" @input="handleMb"  name="search" @keyup.enter.native="handleSearch" size="small" placeholder="请输入内容" clearable>
							<i class="el-icon-search el-input__icon" slot="suffix" style="cursor: pointer;" @click="handleSearch"></i>
						</el-input> -->
						<el-autocomplete
							v-model="serachQuery.search"
							:fetch-suggestions="querySearchAsync"
							:trigger-on-focus="false"
							@keyup.enter.native="handleSearch"
							placeholder="请输入内容"
							size="small"
							clearable 
							@select="handleSelect">
							<i @click="handleSearch" class="el-icon-search el-input__icon" slot="suffix" style="cursor: pointer;"></i>
							<template slot-scope="{ item }">
								<div class="name" v-html="item.value"></div>
							</template>
						</el-autocomplete>
						<el-radio-group v-model="serachQuery.isAll">
							<el-radio :label="true">全文</el-radio>
							<el-radio :label="false">智能</el-radio>
						</el-radio-group>
						<!-- <el-dropdown size="mini" @command="handleCommandAdd"> -->
							<!-- <el-button @click.stop="handleCommandAdd('1')" v-show="currentNode.level && currentNode.level > 1" size="mini" type="primary">新增</el-button> -->
							<!-- <el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="1">新增知识</el-dropdown-item>
								<el-dropdown-item command="2">新增流程</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown> -->
						<div class="mb-cls" v-show="mbList.length != 0">
							<div @click.stop="handleBigScreenInfo(item, item.type == '2' ? 'process' : '')" class="cell" v-for="(item, index) in mbList" :key="index">
								<span v-html="item.q"></span>
							</div>
						</div>
					</div>
					
					<div class="breadcrumb-cls">
						<div class="bre-cls">
							<el-breadcrumb separator="/">
								<!-- <el-breadcrumb-item >全部资源</el-breadcrumb-item> -->
								<el-breadcrumb-item v-for="(item, index) in currentNodeNameList" :key="index">
									<span style="font-weight: 900 !important;">{{item.name}}</span>
								</el-breadcrumb-item>
							</el-breadcrumb>
						</div>
						<!-- <div class="date-cls">
							<el-dropdown @command="handleCommand">
								<span class="el-dropdown-link">
									{{clickedText}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="今天点击">今天点击</el-dropdown-item>
									<el-dropdown-item command="近3天点击">近3天点击</el-dropdown-item>
									<el-dropdown-item command="近7天点击">近7天点击</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div> -->
					</div>
					<!-- <div class="tabs-cls">
						<span @click.stop="handleTypeSwitch('2')" :class="{'is-active': listQuery.type === '2'}">流程</span>
						<span @click.stop="handleTypeSwitch('1')" :class="{'is-active': listQuery.type === '1'}">知识</span>
					</div> -->
					<div v-if="listQuery.type === '1'" class="list-cls" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
						<div class="cell" v-for="(item, index) in list" :key="index">
							<div class="top-cls">
								<span @click.stop="handleShowUnfold(item, index)">
									<svg-icon style="margin-right: 8px" icon-class="KnowArticle" />
									<span v-html="item.q"></span>
								</span>
								<span v-show="item.hot == 1">hot</span>
								<span>
									<u>查看量：<s>{{item.click}}</s></u>
									<svg-icon @click.stop="handleBigScreenUpdate(item)" icon-class="KnowEdit" />
									<svg-icon @click.stop="handleBigScreenInfo(item)" icon-class="KnowFullScreen" />
								</span>
							</div>
							<div class="bottom-cls">
								<el-collapse-transition>
									<div v-show="showUnfoldId != item.id" class="describe-cls" style="height: 40px; margin: 0;overflow: hidden;border: none;">
										<p v-html="item.ashort" style="height: 40px !important; font-weight: 400;"></p>
									</div>
								</el-collapse-transition>
								<el-collapse-transition>
									<div class="divv" v-show="showUnfoldId == item.id">
										<div class="describe-cls" style="padding-left: 22px; margin: 0;border: none;">
											<span v-if="item.parentNode" v-for="(v, i) in item.parentNode" :key="i">
												<!-- <span v-if="resource.name">{{resource.name}}</span> -->
												{{v.name}}
												<i v-show="i+1 !== item.parentNode.length"> / </i>
											</span>
										</div>
										<div class="html-cls" v-html="item.a"></div>
										<div class="help-cls">
											是否有帮助？ <svg-icon :class="{'agree': item.helpType === 'agree'}" @click.stop="handleHelp(item, index, true)" style="margin-left: 12px" icon-class="Agree" /> <svg-icon style="margin-left: 16px" :class="{'no-agree': item.helpType === 'no-agree'}" @click.stop="handleHelp(item, index, false)" icon-class="NoAgree" />
											<span>最近修改：{{item.lastUpdateTime | formatDate}}</span>
											<span>查看量：{{item.click}}</span>
											<span>有帮助：{{item.help}}</span>
											
										</div>
										<!-- <div class="describe-cls">
											<p>
												<span>有帮助：{{item.help}}</span>
												<span>查看量：{{item.click}}</span>
												<span>最近修改：{{item.lastUpdateTime | formatDate}}</span>
											</p>
										</div> -->
										<div class="associated-cls" v-if="list[sjs]">
											<div class="title-cls">相关知识</div>
											<div class="btns-cls">
												<el-button @click.stop="handleBigScreenInfo(list[sjs], list[sjs]['type'] == '2' ? 'process' : '')" type="primary" size="mini" plain round>{{list[sjs]['q']}}</el-button>
												<!-- <el-button v-if="list.length > 1" @click.stop="handleBigScreenInfo(list[sjs === 6 ? sjs - 1 : sjs + 1], list[sjs]['type'] == '2' ? 'process' : '')" type="primary" size="mini" plain round>{{list[sjs === 6 ? sjs - 1 : sjs + 1]['q']}}</el-button> -->
											</div>
										</div>
										<!-- <div class="tabs-cls">
											<el-tabs v-model="activeName">
												<el-tab-pane label="评论" name="first">
													<el-empty description="暂无数据"></el-empty>
												</el-tab-pane>
												<el-tab-pane label="附件" name="second">
													<el-empty description="暂无数据"></el-empty>
												</el-tab-pane>
												<el-tab-pane label="历史记录" name="third">
													<el-empty description="暂无数据"></el-empty>
												</el-tab-pane>
											</el-tabs>
										</div> -->
									</div>
								</el-collapse-transition>
							</div>
						</div>
						<div class="station" v-if="loading">加载中...</div>
						<div class="station" v-if="!loading && noMore && list.length !== 0">没有更多了</div>
						<el-empty v-if="list.length === 0" description="暂无数据"></el-empty>
					</div>

					<div v-if="listQuery.type === '2'" class="list-process-cls" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
						<div class="cell" v-for="(item, index) in list" :key="index">
							<div class="top-cls">
								<span @click.stop="handleBigScreenInfo(item, 'process')">
									<svg-icon style="margin-right: 8px" icon-class="KnowProcess" />
									<span v-html="item.q"></span>
								</span>
								<span v-show="item.hot == 1">hot</span>
								<span>
									<u>查看量：<s>{{item.click}}</s></u>
									<!-- <svg-icon @click.stop="handleBigScreenUpdate(item)" icon-class="KnowEdit" /> -->
									<svg-icon @click.stop="handleBigScreenInfo(item, 'process')" icon-class="KnowFullScreen" />
								</span>
							</div>
						</div>
						<div class="station" v-if="loading">加载中...</div>
						<div class="station" v-if="!loading && noMore && list.length !== 0">没有更多了</div>
						<el-empty v-if="list.length === 0" description="暂无数据"></el-empty>
					</div>

				</div>
			</div>

			<!-- 知识详情 弹出 -->
			<div class="modal-cls" v-show="bigScreenType !== ''">
				<div class="modal-header-cls">
					<span v-show="['process', 'info'].includes(bigScreenType)" class="title">
						<svg-icon v-if="bigScreenType === 'info'" style="margin-right: 8px" icon-class="KnowArticle" />
						<svg-icon v-if="bigScreenType === 'process'" style="margin-right: 8px" icon-class="KnowProcess" />
						<span v-html="qaDetail.q"></span>
					</span>
					<span v-show="['createKnowledge', 'updateKnowledge'].includes(bigScreenType)" class="title">{{bigScreenType === 'createKnowledge' ? '新增' : '编辑'}}知识点</span>
					<svg-icon @click.stop="bigScreenType = '';" icon-class="KnowNoFullScreen" />
				</div>
				<div class="modal-context-cls">
					<Info v-if="bigScreenType === 'info'" :qaDetail="qaDetail" :sourceList="list" :sjs="sjs" @emitScreenInfo="handleBigScreenInfo" />
					<UpdateKnowledge @MinimizeWindow="bigScreenType = '';" v-if="bigScreenType === 'updateKnowledge'" :qaDetail="qaDetail" :currentNodeNameList="currentNodeNameList" />
					<ProcessInfo v-if="bigScreenType === 'process'" :qaDetail="qaDetail" :sourceList="list" :sjs="sjs" @emitScreenInfo="handleBigScreenInfo" />
					<CreateKnowledge @MinimizeWindow="bigScreenType = '';" v-if="bigScreenType === 'createKnowledge'" :currentNode="currentNode" :currentNodeNameList="currentNodeNameList" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Info from './Info';
import CreateKnowledge from './CreateKnowledge';
import UpdateKnowledge from './UpdateKnowledge';
import ProcessInfo from './ProcessInfo';
export default {
	name: 'KonwledgeComponent',
	components: {Info, UpdateKnowledge, CreateKnowledge, ProcessInfo},
	computed: {
		...mapGetters([
			'sidebar',
			'avatar',
			'device',
			'name',
			'userInfo',
		]),
		noMore() {
			return this.listQuery.pageNum >= this.totalSize ;
		},
		disabled() {
			return this.loading || this.noMore;
		},
	},
	data() {
		return {
			sjs: Math.floor(Math.random() * 6),
			isUnfoldSidebar: true,
			showUnfoldId: '',
			activeName: 'first',
			clickedText: '今天点击',
			defaultProps: {
				children: 'children',
				label: 'name'
			},
			serachQuery: {
				isAll: true,
				pageNum: 1,
				pageSize: 10,
				projectId: '',
				type: '',
				resourceId: '',
				search: ''
			},
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				projectId: '',
				type: '2',
				treeId: '',
				resourceId: ''
			},
			list: [],
			totalSize: 0,
			loading: false,
			currentNode: {},
			currentNodeId: '',
			currentNodeIdList: [],
			currentNodeNameList: [],
			isSearch: false,
			newList: [],
			bigScreenType: '',
			qaDetail: {},
			currentType: '',
			mbList: [],
			restaurants: [],
			timeout: null
		}
	},
	created() {
		this.getNewList();
	},
	methods: {
		...mapMutations({
			'SET_IS_KNOWLEDGE': 'app/SET_IS_KNOWLEDGE',
		}),
		querySearchAsync(queryString, cb) {
			const self = this;
			let resourceId = '';
			if(self.currentNode?.data) {
				resourceId = self.currentNode?.data.resourceId ? self.currentNode?.data.resourceId : self.currentNode?.data.id;
			} else {
				resourceId = self.currentNode.id;
			}
			
			if(queryString) {
				self.$api.apiPostKnowledgeSelectQAByKeyWord({
					KeyWord: queryString,
					projectId: self.userInfo.brandIdentify,
					resourceId: resourceId,
					type: self.currentType
				}).then(response => {
					if(response.errcode != 0) return;
					let restaurants = response.data ? response.data : [];
					for(const item of restaurants) {
						item['value'] = item.q;
					}
					cb(restaurants);
				});
			} else {
				cb([]);
			}
			
		},
		handleSelect(item) {
			this.serachQuery.search = this.serachQuery.search.replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
			// this.handleBigScreenInfo(item, item.type == '2' ? 'process' : '');
			this.handleSearch();
		},
		handleCommandAdd(type) {
			this.currentNode['qaType'] = type;
			this.bigScreenType = 'createKnowledge';
		},
		handleUnfold() {
			this.isUnfoldSidebar = !this.isUnfoldSidebar;
		},
		handleHelp(item, index, type, category) {
			const self = this;
			if(item.isHelp) return;
			item['isHelp'] = true;
			item['helpType'] = type ? 'agree' : 'no-agree';
			if(category === 'detail') {
				Vue.set(self.qaDetail, item);
			} else {
				Vue.set(self.list[index], item);
			}
			self.$api.apiPostKnowledgeSetHelp({
				projectId: self.userInfo.brandIdentify,
				id: item.id,
				type: type ? 1 : 2
			});
		},
		handleMb(val) {
			if(val) {
				let resourceId = '';
				if(this.currentNode?.data) {
					resourceId = this.currentNode?.data.resourceId ? this.currentNode?.data.resourceId : this.currentNode?.data.id;
				} else {
					resourceId = this.currentNode.id;
				}
				this.mbList = [];
				this.$api.apiPostKnowledgeSelectQAByKeyWord({
					KeyWord: val,
					projectId: this.userInfo.brandIdentify,
					resourceId: resourceId,
					type: this.currentType
				}).then(response => {
					if(response.errcode != 0) return;
					this.mbList = response.data ? response.data : [];
				});
			} else{
				this.mbList = [];
			}
		},
		handleShowUnfold(item, index) {
			const self = this;
			if(item.id === self.showUnfoldId) {
				self.showUnfoldId = '';
				return;
			}
			// ! 获取QA详情
			self.$api.apiPostKnowledgeQAInfo({id: item.id, projectId: self.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) {
					return;
				}
				if(self.serachQuery.search) {
					response.data['q'] = item['q'];
					response.data['ashort'] = item['a'] && !response.data['ashort'] ? item['a'] : item['ashort'];
				}
				self.list[index] = Object.assign(item, response.data);
				self.showUnfoldId = item.id;
				self.sjs = Math.floor(Math.random() * self.list.length);
			});
			
		},
		handleBigScreenUpdate(item) {
			this.$api.apiPostKnowledgeQAInfo({id: item.id, projectId: this.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) {
					return;
				}
				this.qaDetail = Object.assign(item, response.data);
				this.bigScreenType = 'updateKnowledge';
			});
		},
		handleBigScreenInfo(item, type) {
			this.$api.apiPostKnowledgeQAInfo({id: item.id, projectId: this.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) {
					return;
				}
				this.qaDetail = Object.assign(item, response.data);
				this.bigScreenType = type === 'process' ? 'process' : 'info';
			});
		},
		handleBreadctumbClick(item) {
			this.handleTreeClick(null, {data: item}, null, null);
		},
		getTreeNode(node){ 
            if (node) {
                if (node.label !== undefined) {
					this.currentNodeNameList.unshift(node.data);
                    this.getTreeNode(node.parent);
                }
            }
        },
		handleTreeClick(obj, node, itself, type) {
			this.currentNodeNameList = [];
			this.getTreeNode(this.$refs.tree.getNode(node.key))
			if(node.level === 1) {
				this.currentType = node?.data?.type;
				this.listQuery.resourceId = node?.data?.id;
				this.listQuery.treeId = '';
				this.currentNodeId = node?.data?.id;
			} else if(type === 'first' || !node?.level) {
				this.currentType = node.type;
				this.currentNodeId = node?.id;
				this.currentNodeNameList = [node];
				this.listQuery.resourceId = node?.id;
				this.listQuery.treeId = '';
			} else {
				this.currentType = node?.data?.type;
				this.listQuery.resourceId = node?.data?.resourceId;
				this.listQuery.treeId = node?.data?.id;
				this.currentNodeId = node?.data?.id;
				this.currentNodeIdList.push(node?.data?.id);
			}
			this.currentNode = node;
			this.listQuery.projectId = this.userInfo?.brandIdentify;
			if(type !== 'load') {
				this.listQuery.pageNum = 1;
			}
			this.loading  = true;
			this.listQuery.type = this.currentType;
			this.$api.apiPostKnowledgeQAList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.list = [];
					this.loading = false;
					return;
				}
				if(response?.data && response.data?.rows) {
					this.list = type === 'load' ? this.list.concat(response?.data?.rows) : response?.data?.rows;	
					for(const item of this.list) {
						item['isHelp'] = false;
						item['helpType'] = '';
					}
					this.totalSize = response.data?.totalPage;
				} else {
					this.list = [];
					this.totalSize = 0;
				}
				
				this.loading = false;
			});
		},
		handleSearch(type) {
			if(!this.serachQuery.search) {
				this.handleTreeClick(null, this.currentNode, null, null); 
				return;
			}
			this.isSearch = true;
			
			
			this.serachQuery.projectId = this.userInfo?.brandIdentify;
			if(type !== 'load') {
				this.serachQuery.pageNum = 1;
			}
			this.loading  = true;
			if(this.currentNode?.data) {
				this.serachQuery.resourceId = this.currentNode?.data.resourceId ? this.currentNode?.data.resourceId : this.currentNode?.data.id;
			} else {
				this.serachQuery.resourceId = this.currentNode.id;
			}
			this.serachQuery.type = '';
			if(this.serachQuery.isAll) {
				this.serachQuery.type = this.currentNode.type;
				this.$api.apiPostKnowledgeSearchAll(this.serachQuery).then(response => {
					if(response.errcode != 0) {
						this.list = [];
						this.loading = false;
						return;
					}
					this.list = response?.data ? response?.data : [];
					for(const item of this.list) {
						item['isHelp'] = false;
						item['helpType'] = '';
						item['ashort'] = item['a'];
						item['q'] = item['q'].replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
					}
					this.totalSize = this.list?.length;
					this.loading = false;
					this.sjs = Math.floor(Math.random() * (this.list.length-1));
				});
			} else {
				this.serachQuery.type = this.currentNode.type;
				this.$api.apiPostKnowledgeSearchIntelligent(this.serachQuery).then(response => {
					if(response.errcode != 0) {
						this.list = [];
						this.loading = false;
						return;
					}
					this.list = response?.data ? response?.data : [];
					for(const item of this.list) {
						item['isHelp'] = false;
						item['helpType'] = '';
						item['ashort'] = item['a'];
						item['q'] = item['q'].replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
					}
					this.totalSize = this.list?.length;
					this.loading = false;
					this.sjs = Math.floor(Math.random() * (this.list.length-1));
				});
			}
		},
		loadNode(node, resolve) {
			const self = this;
			if (node.level === 0) {
				self.$api.apiPostKnowledgeResourceByList({
					pageNum: 1,
					pageSize: 99999,
					projectId: self.userInfo.brandIdentify
				}).then(response => {
					if(response.errcode != 0) {
						resolve([]);
						return;
					}
					if(response?.data?.length > 0) {
						this.isSearch = false;
						this.serachQuery.search = '';
						this.handleTreeClick(null, response?.data?.[0], null, 'first');
					}
					return resolve(response?.data ? response?.data : []);
				});
			} else {
				if(node.level === 1) {
					self.$api.apiPostKnowledgeTreeList({
						resourceId: node?.data?.id,
						projectId: self.userInfo.brandIdentify
					}).then(response => {
						if(response.errcode != 0) {
							resolve([]);
							return;
						}
						for(const item of response?.data) {
							item['type'] = node?.data?.['type']
						}
						return resolve(self.translateDataToTree(response?.data ? response?.data : []));
					});
				} else {
					return resolve(node?.data?.children || []);
				}
			}
		},
		handleTypeSwitch(type) {
			this.listQuery.type = type;
			if(this.isSearch) {
				this.handleSearch('load');
				return;
			}
			this.handleTreeClick(null, this.currentNode, null, null);
		},
		load() {
			this.listQuery.pageNum += 1;
			if(this.isSearch) {
				this.handleSearch('load');
				return;
			}
			this.handleTreeClick(null, this.currentNode, null, 'load');
		},
		handleClose() {
			this.SET_IS_KNOWLEDGE(false);
		},
		translateDataToTree(data, parentId = null) {
			const self = this;
			let tree = [];
			let temp;
			data.forEach((item, index) => {
				if (data[index].parentId == parentId) {
				let obj = data[index];
				temp = self.translateDataToTree(data, data[index].id);
				if (temp?.length > 0) {
					obj.children = temp;
				}
				tree.push(obj);
				}
			})
			return tree;
		},
		getNewList() {
			this.$api.apiPostKnowledgeSelectNewQaList({
				projectId: this.userInfo.brandIdentify
			}).then(response => {
				if(response.errcode != 0) return;
				const baseArray = response.data;
				const len = baseArray.length;
				const n = 2;
				const lineNum = len % n === 0 ? len / n : Math.floor( (len / n) + 1 );
				for (let i = 0; i < lineNum; i++) {
					let temp = baseArray.slice(i*n, i*n+n);
					this.newList.push(temp);
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .el-tree-node__label {
	font-weight: bold;
}
::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #E6E9EF;
}

.konwledge-diog-cls {
	width: calc(100% - 33%);
	height: calc(100vh - 60px);
	position: absolute;
	top: 60px;
	left: 33%;
	z-index: 2000;
	background: #F7F8FA;
	box-shadow: 0px 0 8px 4px rgba(0, 0, 0, 0.14);
	border-radius: 2px;
	border: solid 1px #DCDFE6;
	box-sizing: border-box;

	& > .modal-cls {
		width: 100%;
		height: 100%;
		background: #F7F8FA;
		position: absolute;
		top: 0;
		left: 0;
		overflow-x: hidden;
		overflow-y: auto;
		z-index: 2000;

		& > .modal-header-cls {
			width: 100%;
			height: 60px;
			cursor: move;
			padding: 0 20px;
			box-sizing: border-box;
			border-bottom: 1px solid #D8D8D8;

			& > .svg-icon {
				font-size: 18px;
				color: #566980;
				vertical-align: top;
				cursor: pointer;
				float: right;
				margin-top: 20px;
			}

			& > .title {
				font-size: 16px;
				font-weight: bold;
				color: #3C4353;
				vertical-align: top;
				line-height: 60px;
			}
		}

		& > .modal-context-cls {
			width: 100%;
			height: calc(100% - 80px);
			overflow-x: hidden;
			overflow-y: auto;
		}
	}

	& > .konwledge-diog-header-cls {
		width: 100%;
		height: 60px;
		cursor: move;
		border-bottom: 1px solid #D8D8D8;

		& > .left-header-cls {
			width: 0;
			height: 100%;
			display: inline-block;
			vertical-align: top;
			box-sizing: border-box;
			overflow: hidden;
			transition: width .2s;

			&.is-unfold-sidebar-width {
				width: 300px;
			}

			& > div {
				width: 300px;
				padding: 10px 20px;
				box-sizing: border-box;
				& > .logo {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					margin-right: 10px;
					display: inline-block;
				}

				& > span {
					font-size: 16px;
					font-weight: 500;
					color: #3C4353;
					line-height: 40px;
					margin-right: 8px;
					vertical-align: top;

					&:nth-of-type(2) {
						color: #6C7E91;
						font-weight: 400;
					}
				}

				::v-deep .el-badge {
					float: right;
					margin-top: 10px;
				}

				& .msg {
					vertical-align: top;
					font-size: 25px;
					color: #566980;
					cursor: pointer;
				}
			}
		}

		& > .right-header-cls {
			width: 100%;
			height: 100%;
			display: inline-block;
			vertical-align: top;
			padding: 0 12px 0 20px;
			box-sizing: border-box;
			border-left: 1px solid #D8D8D8;
			overflow: hidden;
			transition: width .2s;
			
			&.is-unfold-content-width {
				width: calc(100% - 300px);
			}

			& > .svg-icon {
				font-size: 18px;
				color: #566980;
				margin-right: 10px;
				vertical-align: top;
				cursor: pointer;
				margin-top: 21px;
				float: right;

				&:nth-of-type(1) {
					float: left;
				}
			}

			& > .title {
				font-size: 16px;
				font-weight: bold;
				color: #3C4353;
				vertical-align: top;
				line-height: 60px;
			}
		}
	}

	& > .konwledge-diog-content-cls {
		width: 100%;
		height: calc(100% - 60px);

		& > .left-content-cls {
			width: 0;
			height: 100%;
			display: inline-block;
			vertical-align: top;
			box-sizing: border-box;
			overflow: hidden;
			transition: width .2s;

			& .custom-tree-node {
				font-size: 14px;
				font-weight: bold;
				// color: #172B4D;
			}

			&.is-unfold-sidebar-width {
				width: 300px;
			}

			& > div {
				width: 300px;
				padding: 10px 20px;
				box-sizing: border-box;

				& > .update {
					display: block;
					font-size: 14px;
					font-weight: 500;
					color: #566980;
					line-height: 44px;
					padding: 0 5px;
					box-sizing: border-box;
					border-bottom: 1px solid #D8D8D8;

					& > i {
						font-size: 11px;
						color: #fff;
						background: #FF504D;
						border-radius: 9px;
						width: 18px;
						height: 18px;
						padding: 0 4px;
						box-sizing: border-box;
						line-height: 18px;
						font-style: normal;
						margin-left: 5px;
					}
				}

				& > .title {
					font-size: 14px;
					font-weight: 500;
					color: #337EFF;
					line-height: 40px;
					padding: 0 5px;
					box-sizing: border-box;
				}

				& .el-tree {
					background: transparent;
				}
			}
		}
		& > .right-content-cls {
			width: 100%;
			height: 100%;
			display: inline-block;
			vertical-align: top;
			border-left: 1px solid #D8D8D8;
			overflow: hidden;
			transition: width .2s;
			
			&.is-unfold-content-width {
				width: calc(100% - 300px);
			}

			& > .query-cls {
				width: 100%;
				height: 53px;
				padding: 14px 20px 7px;
				box-sizing: border-box;
				position: relative;

				& > .svg-icon {
					font-size: 28px;
					margin-right: 8px;
					line-height: 36px;
				}

				

				& > span {
					font-size: 12px;
					font-weight: 400;
					color: #3C4353;
					line-height: 32px;
				}

				& .el-autocomplete {
					width: calc(100% - 246px);
					vertical-align: top;
				}

				& > .mb-cls {
					width: calc(100% - 165px);
					position: absolute;
					top: 50px;
					left: 80px;
					background: darkgoldenrod;
					z-index: 2000;
					background: #FFFFFF;
					box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.07);
					border-radius: 4px;
					border: 1px solid #D8D8D8;
					padding: 5px 0;
					box-sizing: border-box;

					& > .cell {
						width: 100%;
						height: 40px;
						font-size: 13px;
						font-weight: 400;
						color: #3C4353;
						line-height: 40px;
						cursor: pointer;
						padding: 0 10px;
						box-sizing: border-box;

						&:hover {
							background: #F2F8FF;
						}
					}
				}

				& .el-radio {
					margin: 0;
					margin-left: 8px;
					vertical-align: top;
					position: relative;
					top: -2px;
				}

				& .el-button {
					margin-left: 10px;
				}
			}

			& > .carousel-cls {
				width: 100%;
				height: 56px;
				background: #fcfcfc;


				::v-deep & .el-carousel__button {
					background: #D8D8D8;
					width: 8px;
					height: 8px;
					border-radius: 50%;
					opacity: 1;
				}
				::v-deep .el-carousel__indicator.is-active > button  {
					background: #337EFF;
				}

				& .context {
					width: 480px;
					height: 100%;
					margin: 0 auto;

					& > .cell {
						width: 240px;
						height: 100%;
						display: inline-block;
						vertical-align: top;
						padding-top: 10px;
						padding-left: 50px;
						box-sizing: border-box;
						cursor: pointer;

						& > div:nth-of-type(1) {
							height: 18px;
							& > i {
								display: inline-block;
								width: 38px;
								height: 18px;
								background: #FF504D;
								border-radius: 18px;
								text-align: center;
								font-size: 11px;
								color: #FFFFFF;
								vertical-align: top;
								margin-right: 8px;
								line-height: 18px;

							}
							& > span:nth-of-type(1) {
								font-size: 12px;
								font-weight: 400;
								color: #3C4353;
								line-height: 18px;
								width: 120px;
								display: inline-block;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}

						& > div:nth-of-type(2) {
							font-size: 12px;
							font-weight: 400;
							color: #A6AAB8;
							line-height: 24px;
							margin-top: 3px;

							& > span:last-child > i {
								display: none;
							}
						}
					}
				}
			}

			& > .breadcrumb-cls {
				width: 100%;
				height: 48px;
				padding: 15px 5px 15px 20px;
				box-sizing: border-box;

				& > .bre-cls {
					width: calc(100% - 120px);
					height: 100%;
					vertical-align: top;
					display: inline-block;
					font-size: 12px;
					font-weight: 400;
					color: #6C7E91;
					line-height: 18px;

					
				}

				& > .date-cls {
					vertical-align: top;
					width: 100px;
					height: 100%;
					float: right;
					text-align: center;
				}
			}

			& > .tabs-cls {
				width: 100%;
				height: 38px;
				line-height: 38px;
				font-size: 14px;
				font-weight: 400;
				color: #3C4353;
				padding: 0 18px;
				box-sizing: border-box;

				& > span {
					display: inline-block;
					width: 50%;
					border-bottom: solid 1px #D8D8D8;
					cursor: pointer;
					text-align: center;
					font-weight: 900;

					&.is-active {
						border-color: #337EFF;
						color: #337EFF;
						border-bottom: solid 2px #337EFF;
					}
				}
			}

			& > .list-cls {
				width: 100%;
				height: calc(100% - 220px);
				overflow-x: hidden;
				overflow-y: auto;

				& > .cell {
					width: 100%;
					// height: 90px;
					border-bottom: 1px dashed #D8D8D8;
					padding: 12px 18px 8px;
					box-sizing: border-box;

					& > .top-cls {
						width: 100%;
						height: 20px;
						margin-bottom: 10px;

						& > span {
							font-size: 14px;
							font-weight: 500;
							color: #3C4353;
							line-height: 20px;
							cursor: pointer;

							&:nth-of-type(1) {
								display: inline-block;
								width: calc(100% - 260px);
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}

							&:nth-of-type(2) {
								display: inline-block;
								width: 38px;
								height: 18px;
								background: #FF5D5D;
								border-radius: 18px;
								text-align: center;
								font-size: 11px;
								color: #FFFFFF;
								vertical-align: top;
								margin-left: 8px;
								line-height: 18px;
							}

							&:nth-of-type(3) {
								width: 200px;
								height: 100%;
								float: right;
								text-align: right;

								& > u {
									font-size: 14px;
									font-weight: 400;
									color: #3C4353;
									line-height: 20px;
									font-style: normal;
									text-decoration: none;
									& > s {
										color: #337EFF;
										text-decoration: none;
										margin-right: 20px;
									}
								}

								& > .svg-icon {
									font-style: normal;
									color: #6C7E91;
									font-style: 14px;
									line-height: 20px;
									margin-left: 15px;
									cursor: pointer;
									font-weight: bold;
									transition: transform .2s;
								}

								& > i {
									font-style: normal;
									color: #6C7E91;
									font-style: 14px;
									line-height: 20px;
									margin-left: 8px;
									cursor: pointer;
									font-weight: bold;
									transition: transform .2s;

									&:nth-of-type(3).is-active {
										transform: rotate(90deg);
									}
								}
							}
						}
					}

					& > .bottom-cls {
						width: 100%;

						& .describe-cls {
							font-size: 12px;
							font-weight: 400;
							color: #6C7E91;
							line-height: 24px;
							margin-bottom: 10px;
							border-bottom: 1px solid #efefef;
							font-weight: 900;
							
							& > p {
								line-height: 20px;
								margin-bottom: 3px;

								& > span {
									margin-right: 20px;

									&:nth-of-type(3) {
										float: right;
										margin: 0;
									}
								}
							}
						}

						& .divv > .html-cls {
							margin-top: 30px;
							width: 100%;
							height: auto;
							padding: 0 20px 30px;
							box-sizing: border-box;
							margin-bottom: 11px;
							font-size: 14px;
							font-weight: 400;
							color: #6C7E91;
							line-height: 22px;

							::v-deep img {
								width: 100% !important;
							}
						}

						& .divv > .help-cls {
							width: 100%;
							height: 24px;
							font-size: 12px;
							font-weight: 400;
							color: #A6AAB8;
							line-height: 24px;
							text-align: left;
							margin-bottom: 6px;
							padding-bottom: 30px;
							box-sizing: border-box;
							border-bottom: solid 1px #efefef;

							& > span {
								text-align: right;
								float: right;
								margin-left: 15px;
							}
							
							& .svg-icon {
								cursor: pointer;
								font-size: 16px;

								&.agree {
									color: #f29521;
								}

								&.no-agree {
									color: #ff504d;
								}
							}
						}

						& .divv > .associated-cls {
							width: 100%;
							margin-bottom: 20px;

							& > .title-cls {
								font-size: 12px;
								font-weight: 400;
								color: #A6AAB8;
								line-height: 24px;
								margin-bottom: 2px;
							}

							& > .btns-cls {
								width: 100%;
								height: 24px;
								margin-bottom: 18px;
								color: #337EFF;
							}
						}

						& .divv > .tabs-cls {
							width: 100%;
							padding-bottom: 50px;
							box-sizing: border-box;
						}
					}
				}

				& > .station {
					font-size: 14px;
					color: #909399;
					line-height: 70px;
					text-align: center;
				}
			}

			& > .list-process-cls {
				width: 100%;
				height: calc(100% - 220px);
				overflow-x: hidden;
				overflow-y: auto;

				& > .cell {
					width: 100%;
					height: 56px;
					border-bottom: 1px dashed #D8D8D8;
					padding: 0 18px;
					line-height: 56px;
					box-sizing: border-box;

					& > .top-cls {
						width: 100%;
						height: 56px;

						& > span {
							font-size: 14px;
							font-weight: 500;
							color: #3C4353;
							line-height: 56px;
							cursor: pointer;

							&:nth-of-type(1) {
								display: inline-block;
								width: calc(100% - 260px);
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}

							&:nth-of-type(2) {
								display: inline-block;
								width: 38px;
								height: 18px;
								background: #FF5D5D;
								border-radius: 18px;
								text-align: center;
								font-size: 11px;
								color: #FFFFFF;
								vertical-align: top;
								margin-left: 8px;
								line-height: 18px;
							}

							&:nth-of-type(3) {
								width: 200px;
								height: 100%;
								float: right;
								text-align: right;

								& > u {
									font-size: 14px;
									font-weight: 400;
									color: #3C4353;
									line-height: 20px;
									font-style: normal;
									text-decoration: none;
									& > s {
										color: #337EFF;
										text-decoration: none;
										margin-right: 20px;
									}
								}

								& > .svg-icon {
									font-style: normal;
									color: #6C7E91;
									font-style: 14px;
									line-height: 20px;
									margin-left: 15px;
									cursor: pointer;
									font-weight: bold;
									transition: transform .2s;
								}

								& > i {
									font-style: normal;
									color: #6C7E91;
									font-style: 14px;
									line-height: 20px;
									margin-left: 8px;
									cursor: pointer;
									font-weight: bold;
									transition: transform .2s;

									&:nth-of-type(3).is-active {
										transform: rotate(90deg);
									}
								}
							}
						}
					}
				}

				& > .station {
					font-size: 14px;
					color: #909399;
					line-height: 70px;
					text-align: center;
				}
			}
		}
	}
}
</style>